<template lang="pug">
  #stock-menu
    md-tabs(:md-active-tab="activeTab")
      md-tab(id="tab-freight-statuses" md-label="Статусы отслеживания груза" v-bind:to="{ name: 'TrackingStatuses'}")
</template>

<script>
  export default {
    name: 'stock-menu',
    data() {
      return {
        title: '',
        activeTab: ''
      }
    },
    watch: {
      '$route'() {
        this.activeTab = 'tab-' + this.$route.meta.tab;
      },
    },
    computed: {},
    created() {
      this.activeTab = 'tab-' + this.$route.meta.tab;
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// menu.vue?aec0bdb8